<template>
	<div class="loader-wrapper">
		<div class="dot-floating">
			<slot></slot>
		</div>
	</div>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
	msg: String,
});
</script>

<style lang="scss" scoped>
.loader-wrapper {
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	top: 0;
	right: 0;
	z-index: 1000;
	background-color: rgba(255, 255, 255, 0.5);
	border-radius: 0;
	overflow: hidden;

	.dot-floating {
		position: relative;
		width: 10px;
		height: 10px;
		border-radius: 5px;
		background-color: #000000;
		color: #000000;
		animation: dotFloating 3s infinite cubic-bezier(0.15, 0.6, 0.9, 0.1);

		&::before {
			content: '';
			display: inline-block;
			position: absolute;
			top: 0;
			left: -12px;
			width: 10px;
			height: 10px;
			border-radius: 5px;
			background-color: #000000;
			color: #000000;
			animation: dotFloatingBefore 3s infinite ease-in-out;
		}

		&::after {
			content: '';
			display: inline-block;
			position: absolute;
			top: 0;
			left: -24px;
			width: 10px;
			height: 10px;
			border-radius: 5px;
			background-color: #000000;
			color: #000000;
			animation: dotFloatingAfter 3s infinite cubic-bezier(0.4, 0, 1, 1);
		}
	}
}

@keyframes dotFloating {
	0% {
		left: calc(-50% - 5px);
	}

	75% {
		left: calc(50% + 105px);
	}

	100% {
		left: calc(50% + 105px);
	}
}

@keyframes dotFloatingBefore {
	0% {
		left: -50px;
	}

	50% {
		left: -12px;
	}

	75% {
		left: -50px;
	}

	100% {
		left: -50px;
	}
}

@keyframes dotFloatingAfter {
	0% {
		left: -100px;
	}

	50% {
		left: -24px;
	}

	75% {
		left: -100px;
	}

	100% {
		left: -100px;
	}
}</style>
